import React from 'react'
import { getEDHClientId } from '../../../lib/environment'
import Heading from 'constructicon/heading'
import LoginForm from 'supporticon/components/login-form'

const Everydayhero = ({ buttonProps, onSuccess }) => (
  <div>
    <Heading>Login to your account</Heading>
    <LoginForm
      clientId={getEDHClientId()}
      formProps={{ submit: buttonProps }}
      onSuccess={onSuccess}
    />
  </div>
)

export default Everydayhero
